<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 8 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0H0V16H8V0Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'FMark',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
